import { saveAs } from 'file-saver'
import * as XLSX from 'xlsx'
import type { StaticFormConfig } from './staticFormsConfig'

const worksheetFromRows = (rows: (string | number)[][]) => XLSX.utils.aoa_to_sheet(rows)

const buildWorkbook = (form: StaticFormConfig) => {
  const rows: (string | number)[][] = [
    ['formCode', form.code],
    ['formTitle', form.title],
    ['remarks', ''],
    ['exportedAt', new Date().toISOString()],
    [],
    ['Section', 'Field Key', 'Label/Item', 'Type', 'Value (Yes/No/NA)'],
  ]

  form.fields.forEach((field) => {
    if (field.type === 'checklist' && field.items) {
      field.items.forEach((item) => {
        rows.push([field.label, field.name, item, 'checklist', ''])
      })
      return
    }
    rows.push(['Field', field.name, field.label, field.type, ''])
  })

  const workbook = XLSX.utils.book_new()
  const sheet = worksheetFromRows(rows)
  sheet['!cols'] = [
    { wch: 22 },
    { wch: 24 },
    { wch: 90 },
    { wch: 16 },
    { wch: 20 },
  ]
  XLSX.utils.book_append_sheet(workbook, sheet, 'Form')

  return workbook
}

export const buildOfflineExcelFile = (form: StaticFormConfig) => {
  const workbook = buildWorkbook(form)
  const data = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' })
  return new File([data], `${form.code}-offline-template.xlsx`, {
    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  })
}

export const downloadOfflineExcel = (form: StaticFormConfig) => {
  const file = buildOfflineExcelFile(form)
  saveAs(file, file.name)
}
